export const resumeData = {
  meta: {
    name: "Mathiarasan Sankaramoorthy",
    title: "Founder & AI Solutions Architect",
    location: "Chennai, India",
    email: "mathi@yalabs.tech",
    social: {
      linkedin: "https://www.linkedin.com/in/mathiarasan-sankaramoorthy-905570104/",
      portfolio: "https://portfolio.yalabs.tech/"
    },
    profileImage: require('../assets/mathi_profile.jpeg')
  },

   professionalSummary: `Technical Architect and Founder specializing in scalable web and AI-driven solutions. Experienced across ERP, Healthcare, and Fintech, guiding teams from idea to impact through modern stacks and LLM integrations.`,
  // `
  //   Technical Architect with extensive experience in building complex applications and integrating AI solutions. 
  //   Proven track record in leading cross-functional teams, redesigning legacy applications to modern JavaScript-based SPAs, 
  //   and delivering high-impact training programs. Domain expertise spans ERP (5 years), Healthcare (3 years), and Fintech (1 year).
  //   Specializes in ML/AI engineering, LLM integrations, and consulting startups on tech strategy and AI implementation.
  //   Passionate mentor and trainer with expertise in MERN stack, LLM integrations, and AI-powered development.`, // Update with actual summary

  skills: {
    technical: {
      "Languages": ["Java 8", "JavaScript (ES6)", "Python", "Node.js", "GoLang"],
      "AWS Services": ["ECS Clusters", "SNS", "SQS", "Lambda", "API Gateway", "DynamoDB", "RDS"],
      "Backend": ["Spring Boot", "Express", "Flask"],
      "Frontend": ["React.js", "Next.js", "HTML", "CSS", "Bootstrap", "Tailwind"],
      "API Technologies": ["REST (Spring Boot)", "AWS API Gateway", "Postman"],
      "Database": ["MongoDB", "Postgres", "Amazon Aurora (Postgres)"],
      "Architecture": ["Microservices", "Event Sourcing"],
      "DevOps": ["Docker", "ECS", "Kubernetes"],
      "Tools": ["Temporal", "Kafka"],
      "AI/ML": ["Hugging Face", "GCP Vertex AI", "Collab", "Jupyter Notebook"],
      "NLP and OCR": ["Tesseract", "Spacy", "LLama2", "RAG", "ChromaDB", "Gemini Pro"]
    },
    soft: [
      "Technical Leadership",
      "Solution Architecture",
      "Team Building",
      "Project Management",
      "Training & Mentoring",
      "Cross-functional Collaboration",
      "Agile/Scrum",
      "TDD",
      "CI/CD"
    ]
  },

  experience: [
    {
      company: "Yalabs Solutions Pvt.Ltd.",
      role: "Founder & Consultant",
      startDate: "Jun 2024",
      endDate: "Present",
      achievements: [
        "Built and launched multiple projects including ChessBrigade, Talebisi, Carrytoo",
        "Acted as technical consultant for e-commerce, fintech, and logistics startups",
        "Delivered workshops and internship programs on MERN stack, LLMs, RAG architecture",
        "Guided startups from product ideation to launch, covering MVP development",
        "Handled project deliveries with remote teams, interns, and contractual developers",
        "Integrated Gemini Pro, LLaMA 2, ChromaDB, Hugging Face models into real-world use cases"
      ],
      technologies: ["React", "Node.js", "Next.js", "Spring Boot", "Python", "Hugging Face", "Vertex AI", "AWS", "Docker", "Shopify App Dev", "ECS", "MongoDB", "Postgres"]
    },
    {
      company: "Element5",
      role: "Associate Tech Architect",
      startDate: "Oct 2021",
      endDate: "Apr 2024",
      projects: [
        {
          title: "Platform for Building and Running Workflows at Scale",
          period: "Jun 2022 - Apr 2024",
          achievements: [
            "Developed a new platform using Temporal, Kafka, S3, and DynamoDB for enterprise-level workflows",
            "Built and trained a cross-functional team, managing delivery from inception to completion",
            "Deployed the platform as a service with seamless integration of pipelines",
            "Designed and architected platform services, guiding team through challenges",
            "Designed user experience and framework for developers using SDK for workflow development"
          ],
          technologies: ["Temporal", "Java", "Python", "Kafka", "EKS", "S3", "DynamoDB", "AWS Lambda", "Docker"]
        },
        {
          title: "Web Emulation for Cloning web applications",
          period: "Oct 2021 - June 2022",
          achievements: [
            "Developed a product that clones web application front-ends for RPA-based automations",
            "Managed entire project lifecycle from conceptualization to implementation",
            "Created a front-end application using React and a UI library",
            "Enhanced expertise in JavaScript, browser extensions, Node.js, Bull Queue"
          ],
          technologies: ["JavaScript (ES6)", "Node.js", "React.js", "Chrome Extension Development", "Bull Queue", "S3"]
        }
      ]
    },
    {
      company: "Ivtl Infoview Technologies",
      role: "Senior Software Engineer",
      startDate: "Jun 2016",
      endDate: "Oct 2021",
      projects: [
        {
          title: "HUE - ERP Product",
          achievements: [
            "Built and maintained SCM modules of a large ERP product",
            "Created full-stack applications using microservices architecture",
            "Guided junior developers and acted as a team player",
            "Contributed to design and architecture of full-stack applications",
            "Expanded knowledge on full stack development with MERN stack"
          ],
          technologies: ["React.js", "Node.js", "Java", "Spring Boot", "Apache Spark", "Kafka", "Postgres", "Cassandra", "MySQL"]
        }
      ]
    }
  ],

  education: [
    {
      degree: "Bachelor of Engineering in Electronics and Communication",
      school: "Kings College of Engineering, Punalkulam (Anna University Chennai)",
      year: "2012 - 2016"
    },
    {
      degree: "Higher Secondary (12th)",
      school: "Kalyana sundaram higher secondary school",
      year: "2010 - 2012"
    },
    {
      degree: "SSLC (10th)",
      school: "Sir Sivaswamy bala vidyalaya matric school, Thanjavur",
      year: "2009 - 2010"
    }
  ],

  consulting: [
    {
      title: "AI Tools Integration Training - AccelTree Technologies",
      scope: "Training engineering teams on AI-enhanced development workflows",
      outcomes: [
        "Successfully trained team on GitHub Copilot integration",
        "Implemented Gemini Pro for code assistance",
        "Established prompt engineering best practices",
        "Enhanced developer productivity through AI tool adoption"
      ]
    },
    {
      title: "Startup AI Strategy Consulting",
      scope: "Technical consultation for startups across multiple domains",
      outcomes: [
        "Guided AI integration strategies for logistics companies",
        "Architected MVP solutions for e-commerce platforms",
        "Designed LLM-based solutions for edtech products",
        "Provided technical roadmap for startups"
      ]
    }
  ],

  trainings: [
    {
      title: "3-Month MERN Stack Course",
      organization: "Uptor",
      type: "Professional Training",
      topics: [
        "MongoDB",
        "Express.js",
        "React with Vite",
        "Node.js",
        "Project Deployment",
        "Real-world Architecture"
      ]
    },
    {
      title: "21-Day Internship Program",
      organization: "GITAM University, Vizag",
      type: "University Program",
      topics: [
        "Full Stack Development",
        "AI Integration",
        "LLM-based Document Processing",
        "OCR Implementation",
        "Intelligent Applications"
      ]
    },
    {
      title: "10-Day Tech Sprint",
      organization: "BITS Pilani, Hyderabad",
      type: "University Program",
      topics: [
        "LLM Integration",
        "Full Stack Development",
        "Document Intelligence",
        "Chatbot Solutions"
      ]
    },
    {
      title: "AI Model Development Workshop",
      organization: "IITM Research Park, Chennai",
      type: "Workshop",
      topics: [
        "Hugging Face Integration",
        "RAG Implementation",
        "Python for ML",
        "Model Deployment"
      ]
    },
    {
      title: "MERN Full Stack Workshop",
      organization: "IITM Research Park, Chennai",
      type: "Workshop",
      topics: [
        "Vite & React",
        "Node.js",
        "MongoDB",
        "Tailwind CSS",
        "Real-time Applications"
      ]
    },
    {
      title: "MERN Stack Sprint",
      organization: "Hyderabad Bootcamp",
      type: "Workshop",
      topics: [
        "Backend API Development",
        "Responsive UI",
        "Database Integration",
        "Complete App Deployment"
      ]
    }
  ],

  portfolio: [
    {
      title: "Enterprise Workflow Platform",
      description: "Platform service for building and running workflows at scale with seamless pipeline integration",
      image: "/images/workflow-platform.jpg",
      role: "Technical Architect",
      techStack: ["Temporal", "Java", "Python", "Kafka", "EKS", "AWS"],
      highlights: [
        "Architected scalable workflow management platform",
        "Led cross-functional team delivery",
        "Implemented event-driven architecture",
        "Designed developer SDK framework"
      ],
      link: "https://element5.io"
    },
    {
      title: "Web Emulation Tool",
      description: "Innovative tool for cloning web applications to enable RPA automation development",
      image: "/images/web-emulator.jpg",
      role: "Lead Developer",
      techStack: ["JavaScript", "React", "Node.js", "Chrome Extensions"],
      highlights: [
        "Built browser-based web application cloning tool",
        "Implemented queue system for task management",
        "Created Chrome extension for web interaction",
        "Designed local deployment system"
      ],
      link: "https://element5.io/products"
    },
    {
      title: "ChessBrigade",
      description: "Interactive chess learning and practice platform",
      image: "/images/chessbrigade.jpg",
      role: "Founder & Developer",
      techStack: ["Next.js", "Node.js", "MongoDB", "AI Integration"],
      highlights: [
        "Built complete chess learning platform",
        "Integrated AI for move analysis",
        "Implemented real-time gameplay",
        "Created interactive learning modules"
      ],
      link: "https://chessbrigade.com"
    },
    {
      title: "HUE ERP System",
      description: "Comprehensive ERP solution with focus on Supply Chain Management",
      image: "/images/hue-erp.jpg",
      role: "Senior Software Engineer",
      techStack: ["React", "Spring Boot", "Kafka", "Postgres"],
      highlights: [
        "Developed SCM module architecture",
        "Implemented microservices design",
        "Built real-time data processing pipeline",
        "Created responsive admin dashboard"
      ],
      link: "https://www.ivtlinfoview.com"
    }
  ]
}